import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from '@/common/api';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.filter('price', val => {
  
  let v = Number(val)
  if (v && !isNaN(v)) {
    return v.toLocaleString()
  }
  return 0
} )

Vue.config.productionTip = false

axios.get('/userinfo').then(res => {
  console.log(res)
  store.commit('updateUser', res.data)
})
axios.get('/specs').then(res => {
  store.commit('setProducts', res.data)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
